import { render, staticRenderFns } from "./EquimentsCategory.vue?vue&type=template&id=536c56e8&"
import script from "./EquimentsCategory.vue?vue&type=script&lang=js&"
export * from "./EquimentsCategory.vue?vue&type=script&lang=js&"
import style0 from "./EquimentsCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports